// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITaxFormMailingHistoryDto } from './ITaxFormMailingHistoryDto';
import {
    ITaxFormMailingHistoryDtoFromJSON,
    ITaxFormMailingHistoryDtoFromJSONTyped,
    ITaxFormMailingHistoryDtoToJSON,
    ITaxFormMailingHistoryDtoToJSONTyped,
} from './ITaxFormMailingHistoryDto';

/**
 * 
 * @export
 * @interface ITaxFormInfoDto
 */
export interface ITaxFormInfoDto {
    /**
     * 
     * @type {number}
     * @memberof ITaxFormInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITaxFormInfoDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ITaxFormInfoDto
     */
    type?: ITaxFormInfoDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ITaxFormInfoDto
     */
    tax_year?: string;
    /**
     * 
     * @type {Date}
     * @memberof ITaxFormInfoDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Array<ITaxFormMailingHistoryDto>}
     * @memberof ITaxFormInfoDto
     */
    mailing_history?: Array<ITaxFormMailingHistoryDto>;
}

/**
* @export
* @enum {string}
*/
export enum ITaxFormInfoDtoTypeEnum {
    TAX_FORM_1099 = 'TAX_FORM_1099',
    TAX_FORM_5498 = 'TAX_FORM_5498',
    TAX_FORM_EXCESS_1099 = 'TAX_FORM_EXCESS_1099'
}


/**
 * Check if a given object implements the ITaxFormInfoDto interface.
 */
export function instanceOfITaxFormInfoDto(value: object): value is ITaxFormInfoDto {
    return true;
}

export function ITaxFormInfoDtoFromJSON(json: any): ITaxFormInfoDto {
    return ITaxFormInfoDtoFromJSONTyped(json, false);
}

export function ITaxFormInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITaxFormInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'mailing_history': json['mailing_history'] == null ? undefined : ((json['mailing_history'] as Array<any>).map(ITaxFormMailingHistoryDtoFromJSON)),
    };
}

export function ITaxFormInfoDtoToJSON(json: any): ITaxFormInfoDto {
    return ITaxFormInfoDtoToJSONTyped(json, false);
}

export function ITaxFormInfoDtoToJSONTyped(value?: ITaxFormInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'tax_year': value['tax_year'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'mailing_history': value['mailing_history'] == null ? undefined : ((value['mailing_history'] as Array<any>).map(ITaxFormMailingHistoryDtoToJSON)),
    };
}

